import React from 'react';
import {Box, Stack, styled} from '@mui/material';

import './loading.animation.scss';

const Container = styled(Stack)`
  background-color: white;
  height: 100%;
  width: 100%;
`;

const Logo = styled('img')`
  height: 18vh;
  margin-bottom: 50px;
`;

const LoadingScreen = () => {
  return (
    <Container alignItems="center" justifyContent="center">
      <Logo alt="metawaste logo" src="/images/metawaste-logo.png"/>
      <Box className="container">
        <Box className="circle"/>
        <Box className="circle"/>
        <Box className="circle"/>
        <Box className="circle"/>
      </Box>
    </Container>
  );
};

export default LoadingScreen;